<template>
    <div class="d-flex align-items-center flex-lg-fill mr-5 my-1" v-if="link">
        <a
            :href="link"
            target="_blank"
            class="d-flex align-items-center text-primary"
        >
            <span class="mr-4">
                <i class="icon-xl las la-file-alt"></i>
            </span>
            <div class="d-flex flex-column">
                <span class="font-weight-bolder font-size-sm">{{ label }}</span>
                <span class="font-weight-bolder font-size-h5" v-if="value">{{
                    value
                }}</span>
            </div>
        </a>
    </div>

    <div
        class="d-flex align-items-center flex-lg-fill mr-5 my-1"
        v-else
        :title="no_link_tooltip"
        data-toggle="tooltip"
    >
        <span class="mr-4">
            <i class="icon-xl las la-file-alt"></i>
        </span>
        <div class="d-flex flex-column flex-lg-fill">
            <span class="font-weight-bolder text-muted" :class="labelClass">{{
                label
            }}</span>
            <span class="font-weight-bolder font-size-h5" v-if="value">{{
                value
            }}</span>
        </div>
    </div>
</template>

<script>
import { initializeTooltip } from "@/utilities/utilities.js";

export default {
    components: {},

    props: ["label", "value", "link", "highlight", "no_link_tooltip"],

    computed: {
        labelClass() {
            if (this.highlight) return "text-warning";
            return "";
        },
    },

    methods: {
        initializeTooltip,
    },

    mounted() {
        this.initializeTooltip();
    },
};
</script>
